import { HotelCardStars } from "@website/accommodation-ui/hotel-card-new/hotel-card-stars";
import { HotelReserveDetailsPropertiesTypes } from "@website/accommodation-ui/hotel-reserve-details/hotel-reserve-details.types";
import { MaterialIcon } from "@website/icons/material";
import { CollapsibleText } from "@website/ui/collapsible-text";
import { deepCompare } from "@website/utils/deep-compare";
import { isRtl } from "@website/utils/is-rtl";
import { numberConvert } from "@website/utils/number-convert";
import toString from "lodash-es/toString";
import { useRouter } from "next/router";
import { memo } from "react";

const Component = (properties: HotelReserveDetailsPropertiesTypes) => {
  const { hotelTitle, stars, address, description } = properties;
  const router = useRouter();

  return (
    <div className="max-w-[1200px] pt-6">
      <h1
        className="pb-1 text-base font-semibold leading-6 lg:pb-4 lg:text-lg xl:text-2xl"
        dir={isRtl(hotelTitle) ? "rtl" : "ltr"}
      >
        {isRtl(hotelTitle)
          ? numberConvert(hotelTitle, { locale: router.locale })
          : toString(hotelTitle)}
      </h1>
      <div className="flex flex-col gap-6">
        <div
          className="text-on-surface-medium-emphasis text-caption lg:text-body-1 flex flex-col items-start gap-1 lg:flex-row lg:items-center lg:gap-4"
          dir={isRtl(address) ? "rtl" : "ltr"}
        >
          {Boolean(stars) && (
            <>
              <div className="hidden lg:block" itemScope>
                <HotelCardStars
                  color="neutral"
                  starSize="medium"
                  stars={stars || 0}
                />
              </div>
              <div className="block lg:hidden" itemScope>
                <HotelCardStars
                  color="neutral"
                  starSize="small"
                  stars={stars || 0}
                />
              </div>
            </>
          )}
          {address && (
            <div className="flex flex-row gap-1">
              <MaterialIcon name="location_on" variant="outlined" />
              <div>
                {isRtl(address)
                  ? numberConvert(address.replaceAll(".", ""), {
                      locale: router.locale
                    })
                  : toString(address)}
              </div>
            </div>
          )}
        </div>
        {description && (
          <div dir={isRtl(description) ? "rtl" : "ltr"}>
            <CollapsibleText
              ariaLabel="details"
              collapsedClassName="h-[40px] md:h-[50px]"
              content={
                <p
                  className="text-on-surface-high-emphasis text-body-2 lg:text-body-1 text-justify"
                  dangerouslySetInnerHTML={{
                    __html: isRtl(description)
                      ? numberConvert(description, { locale: router.locale })
                      : toString(description)
                  }}
                />
              }
              lessText="بستن"
              lessTextIcon={<MaterialIcon name="arrow_drop_up" />}
              moreText="مشاهده بیشتر"
              moreTextIcon={<MaterialIcon name="arrow_drop_down" />}
            />
          </div>
        )}
      </div>
    </div>
  );
};
export const HotelReserveDetails = memo(Component, deepCompare);
